import React, { useEffect } from "react";
import { useAuth } from "react-uicomp";
import CompWrapper from "../hoc/compWrapper/CompWrapper.hoc";

// IMAGES
import PLACEHOLDER from "../../assets/images/library.jpg";
import { TitleB } from "../common/title/Title.common";

const LibraryPage = () => {
  const { setHeaderTitle } = useAuth();

  useEffect(() => {
    setHeaderTitle("Library");
  }, [setHeaderTitle]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <CompWrapper>
      <div>
        <div className="mb-5">
          <TitleB title="Library" />
          <p>
            The Centre has developed its library which has enormous books
            (&gt;5000) and the Journals related to the Agriculture and related
            disciplines.
          </p>
          <p className="mt-3">
            No. of Books available: &gt; 5000 <br />
            No. of News Papers subscribed: 04
          </p>
        </div>
        <img className="image-showcase" width="60%" src={PLACEHOLDER} />
      </div>
    </CompWrapper>
  );
};

export default LibraryPage;
